import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/bytedance/Desktop/gatsby/src/components/BlogLayout/index.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`前言`}</h2>
    <p>{`貌似组内每年都会有一次大型团建，上次是青岛，那个时候我还没加入。`}</p>
    <p>{`这次赶上啦，团建成都。`}</p>
    <p>{`5-13晚首都机场T3飞成都，于双流机场着陆。`}</p>
    <p>{`5-14到5-16按照攻略打卡，看熊猫，逛三星堆博物馆，拜水都江堰，问道青城山。`}</p>
    <p>{`5-17早双流机场起飞，大兴机场降落。`}</p>
    <p>{`一路奔波，旅途收尾。`}</p>
    <p>{`原本想旅途结束当晚就写下这篇文章，但实在是太累了，并不想动，今天算是恢复了些。`}</p>
    <p>{`闭眼沉思，路途经历一幕幕在脑中展现。`}</p>
    <p>{`思如泉涌，落笔成文。`}</p>
    <h2>{`出发前的准备`}</h2>
    <h3>{`攻略制定`}</h3>
    <p>{`如果是有目的的出去玩，不满足于只是随便走走，那做攻略就显得很重要。`}</p>
    <p>{`没有攻略的话，每天的行程就没有什么方向。`}</p>
    <p>{`如果只是换个地方玩手机，还不如回家休息，折腾个啥...`}</p>
    <p>{`在此感谢组内做攻略的张可同学，攻略做的十分全面。`}</p>
    <p>{`从吃吃喝喝到住宿选址，从个人意愿收集到景区购票，旅行安排的明明白白，直呼优秀。`}</p>
    <h3>{`带什么和不带什么`}</h3>
    <p>{`攻略只是第一步，出去玩自然是要带些随身物品。`}</p>
    <p>{`最主要的，带上`}<strong parentName="p">{`手机，充电器，身份证`}</strong>{`，其他的看自己需求。`}</p>
    <p>{`如果玩的时间比较久，建议带些换洗衣物。`}</p>
    <p>{`最好不要带液体，不穿有`}<strong parentName="p">{`皮带`}</strong>{`的裤子， 飞机安检会比较麻烦。`}</p>
    <h3>{`值机与安检`}</h3>
    <p>{`值机就是选座位，使用`}<strong parentName="p">{`航旅纵横APP可以生成电子登机牌`}</strong>{`，和那种柜台办理的纸质机票效果是一样的。`}</p>
    <p>{`不管你是在什么平台买的机票，绑定身份证就能在航旅纵横上看到你的登机信息，十分方便。`}</p>
    <p>{`如果有乘坐飞机的需求，建议下载。温馨提示，尽量早点选。避开那种三四个座位连在一起的，不舒服...`}</p>
    <p>{`飞机的安检是比较严格的。一般会给你一个收纳箱，需要将电子设备，液体，甚至外套单独拿出来，等都检查完毕后通行。至于更精细的，听从安检人员安排就好。`}</p>
    <p>{`最好是提前2-3小时到达，飞机的安检一般耗时比较久，早过去有什么突发情况也有时间解决。`}</p>
    <p>{`到了之后去找你的登机口，机场内会有广播也有指示路线。`}</p>
    <p>{`一般飞机起飞前30分钟登机，起飞前15-20分钟关闭机舱，关了就进不去了...`}</p>
    <p>{`坐在飞机上之后，系好安全带，此时可以玩会手机。等起飞了，就需要关机或者开飞行模式。`}</p>
    <p>{`有的飞机会提供餐食，有的不提供。喝水，要靠枕...有事情找空姐就好,问题不大。`}</p>
    <h2>{`落地休息`}</h2>
    <p>{`时间就是真的很巧，飞机降落时候成都刚好在下雨。打车到了住宿的地方，雨也停了...`}</p>
    <p>{`到的时候是凌晨，和组内其他同事一脸懵逼地找落脚点确切地址。`}</p>
    <p>{`一路绕来绕去，感谢开门的保安大爷和张可同学发的住宿指南，成功入住。`}</p>
    <p>{`人比较多，基本是两个人一张床。我就比较幸运了，选了一张小粉床，就没人和我同住了。`}</p>
    <p>{`哈哈，独享。`}</p>
    <p>{`睡的时候差不多是两点半了，真的好困啊...`}</p>
    <h2>{`看熊猫`}</h2>
    <p>{`第二天一早八点多，组内一行人去吃了肥肠粉，味道还不错。`}</p>
    <p>{`吃完饭后乘坐观光车，第一站去看了熊猫。`}</p>
    <p>{`就觉得，来成都不看看熊猫少了些什么。`}</p>
    <p>{`事实上，大熊猫的形态挺多的，大部分巨胖，肥肥的，圆圆的。`}</p>
    <p><strong parentName="p">{`我看到的第一只：偷看`}</strong></p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210518221729289.png",
        "alt": "第一只"
      }}></img></p>
    <p><strong parentName="p">{`第二只：很悠闲`}</strong></p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210518221840423.png",
        "alt": "第二只"
      }}></img></p>
    <p><strong parentName="p">{`第三只：大家伙`}</strong></p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210518222050650.png",
        "alt": "第三只"
      }}></img></p>
    <p>{`还有的毛脏脏的，白黄相间，啧啧...一言难尽。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210518222148345.png",
        "alt": "脏脏的"
      }}></img></p>
    <p>{`除了真的熊猫，还有很多根据熊猫形态做的熊猫玩偶。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210518222341528.png",
        "alt": "玩偶"
      }}></img></p>
    <p>{`同事有买的，我没买，就看了看。`}</p>
    <p>{`下边这个是熊猫奶茶店的玩偶，坐着迎客，有点东西。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210518223024731.png",
        "alt": null
      }}></img></p>
    <p><strong parentName="p">{`关于拍照技术`}</strong></p>
    <p>{`旅行途中我随手就拍出了被小飞飞嫌弃的照片，嗯，不愧是我。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210518222713815.png",
        "alt": null
      }}></img></p>
    <p>{`对比一下林艳同学的成果，嗯，确实拍照技术比我优秀。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210518222839919.png",
        "alt": null
      }}></img></p>
    <h2>{`逛三星堆`}</h2>
    <p>{`这波没有讲解，纯粹是自己瞎逛，也没看太明白，照片只拍了一张。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210518223215413.png",
        "alt": null
      }}></img></p>
    <p>{`哈哈，血红背景，有点闹鬼的感觉了。`}</p>
    <p>{`三星堆结束晚上去吃了一波性价比很低的火锅，又贵又一般，离谱。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210518223442260.png",
        "alt": null
      }}></img></p>
    <p>{`南方的火锅没有我最喜欢的麻酱，啧啧，难搞。`}</p>
    <p>{`于是乎，回到北京后，我当晚就来了一顿有麻酱的小火锅，完美。`}</p>
    <h2>{`问道青城山`}</h2>
    <p>{`为什么说是问道呢？因为青城山不只有白素贞，还有浓厚的道文化和道馆。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210518223949359.png",
        "alt": null
      }}></img></p>
    <p>{`当然，毕竟也是座山。一路青石台阶，木栈道，索道。`}</p>
    <p>{`看到`}<strong parentName="p">{`上清宫`}</strong>{`，就算是到山顶啦，云雾缭绕的。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/2021051822414458.png",
        "alt": null
      }}></img></p>
    <p>{`近景就是山云相接，适合修仙。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/2021051822430750.png",
        "alt": null
      }}></img></p>
    <p>{`除了这些还有啥呢？有15一桶的泡面，30一个的纪念币...`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210518224431460.png",
        "alt": null
      }}></img></p>
    <p>{`这是我吃过的最贵的泡面，快乐没了。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210518224541904.png",
        "alt": null
      }}></img></p>
    <h2>{`拜水都江堰`}</h2>
    <p>{`都江堰水利工程支撑着整个成都的用水，也是一个五A景区，有点东西。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210518225152569.png",
        "alt": null
      }}></img></p>
    <p>{`这个是有讲解的，一个十分可爱的小姐姐。从排水原理到景点历史，每一点都很细致。`}</p>
    <p>{`虽然没听太懂，但觉得这个导游小姐姐好厉害。`}</p>
    <p>{`让我印象最深的是都江堰有一个`}<strong parentName="p">{`夫妻桥`}</strong>{`，导游小姐姐说情侣要手牵手，爱情更长久。朋友手拉手，友谊天长地久。如果自己一个人，就左手牵右手，图个好运吧，哈哈哈。`}</p>
    <h2>{`钵钵鸡和兔头`}</h2>
    <p>{`最后一晚去吃了春熙路附近的`}<strong parentName="p">{`叶婆婆钵钵鸡`}</strong>{`和街头店随机买的兔头，简直棒棒。`}</p>
    <p>{`兔兔那么可爱，就要吃兔头啊...`}</p>
    <p>{`貌似这也是成都的经典美食，买的人还挺多的。`}</p>
    <h2>{`返航`}</h2>
    <p>{`回来的一路是真的折腾，只觉得大兴机场是真的远。`}</p>
    <p>{`从大兴到草桥，高铁也要走好久。`}</p>
    <p>{`再从草桥到知春路，好家伙，18站地铁，脑瓜子嗡嗡的。`}</p>
    <p>{`第一天两万六千步，第二天两万两千步，真的是，巨减肥...`}</p>
    <p>{`回来后就收心，开始下一阶段的搬砖。`}</p>
    <p><img parentName="p" {...{
        "src": "https://img-blog.csdnimg.cn/20210518225919460.png",
        "alt": null
      }}></img></p>
    <p>{`晚上还有意外之喜，简直双喜临门。`}</p>
    <p>{`微信好友申请是许久不联系的小伙伴，聊了几句，未曾有距离感。`}</p>
    <p>{`开润同学依旧是很可爱，哈哈，整个人快乐翻倍。`}</p>
    <p>{`接着，小婧同学给我发了公众号LOGO的设计图,很有创意，目前已经换上了，简约清新，棒棒。`}</p>
    <p>{`生活啊，总是猝不及防又充满未知和五彩斑斓的黑，当真是，有点东西。`}</p>
    <h2>{`再会`}</h2>
    <p>{`情如风雪无常,`}</p>
    <p>{`却是一动既殇。`}</p>
    <p>{`感谢你这么好看还来阅读我的文章,`}</p>
    <p>{`我是冷月心,下期再见。`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      